/* esm.sh - unhead@3.1.0/dist/shared/unhead.DvIxXxuO */
import{HookableCore as r}from"hookable";function c(o){let n=new r;for(let e in o||{})n.hook(e,o[e]);return n}function a(o,n,e){return o.hooks?.callHook(n,e)}export{a,c};
//# sourceMappingURL=unhead.DvIxXxuO.mjs.map